import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '@services/helper/api-wrapper.service';

/** One prior message replayed to the model for follow-up context. */
export type AiChatHistoryMessage = {
  readonly role: 'user' | 'assistant';
  readonly content: string;
};

/**
 * Data-grounded AI chat (FEC-1227): POST `/ai-chat`. The backend answers from
 * the caller's own, role-scoped project data and returns a short plain-text
 * answer; it responds 404 while the feature is switched off server-side.
 */
@Injectable({ providedIn: 'root' })
export class AiChatApiService {
  private readonly _api = inject(ApiService);

  /** Max prior messages sent — mirrors the server window so we don't ship tokens it would drop. */
  public static readonly HISTORY_LIMIT = 6;

  public ask(question: string, history: readonly AiChatHistoryMessage[]): Observable<string> {
    return this._api
      .post<{ data: { answer: string } }>('/ai-chat', {
        question,
        history: history.slice(-AiChatApiService.HISTORY_LIMIT),
      })
      .pipe(map((res) => res.data.answer));
  }
}
